/*
 * File: \packages\lib\error.js
 * File Created: 2022-03-31 11:03:39
 * Author: Li Haifeng
 * -----
 * Last Modified: 2023-02-09 16:32:16
 * Modified By: Ocean Li ���
 */
import config from "../config.js";

const error = (code, msg = "") => {
  if(msg) {
      msg = `${msg}`;
  }
  throw Error(`${config.errorPreffix}\n${msg}[${code.toString()}]`);
};

const warn = (msg) => {
  console.warn(`${config.warnPreffix}\n${msg}`);
}

const info = (msg) => {
  console.info(`${config.infoPreffix}\n${msg}`);
};

export default { error, warn, info };
